import { render, staticRenderFns } from "./BlockTravelInformationControlFee.vue?vue&type=template&id=32080735&"
import script from "./BlockTravelInformationControlFee.vue?vue&type=script&lang=js&"
export * from "./BlockTravelInformationControlFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports